/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

const RequestButton = ({label, disabled, loading, onClick}) => (
    <button type="submit" disabled={disabled} className="btn btn-md btn-secondary" onClick={onClick}>
        {loading ? <i className="glyphicon glyphicon-refresh normal-right-spinner p-margin-left-xs p-margin-right-xs" /> : null}
        {label}
    </button>
);

RequestButton.propTypes = {
    label: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
};

RequestButton.defaultProps = {};

export default RequestButton;
